import { Box, Button, Grid, Skeleton, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppIcon } from '../../../../components/app-icon/AppIcon';
import { useGetSignedInUser } from '../../../../hooks/useGetSignedInUser';
import { useGuestUserFromStore } from '../../../../hooks/useGuestUserFromStore';
import { openQualificationDrawer } from '../../../../store/features/qualification/qualificationSlice';
import { useAppDispatch } from '../../../../store/hooks';
import { fonts } from '../../../../theme/typography';
import { getEligibleModuleUrl } from '../../../../utils/qualification';
import { EligibleModule } from '../../../eligible-modules/types';
import { eligibilitySectionStyles } from './styles';

interface EligibilityItemCardProps {
  Illustration: React.FC<
    React.SVGProps<SVGSVGElement> & {
      title?: string;
    }
  >;
  content: string;
  module: EligibleModule;
  buttonLabel: string;
}
export const EligibilityItemCard: React.FC<EligibilityItemCardProps> = ({
  Illustration,
  content,
  buttonLabel,
  module,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { isGuestUserFetching, user: guestUser, qualification: guestQualification } = useGuestUserFromStore();
  const { isFetching, currentData: userData } = useGetSignedInUser();

  const onFindEligibleModule = (): void => {
    if (userData?.user) {
      dispatch(openQualificationDrawer(module));
    } else if (guestUser && guestQualification) {
      const url = getEligibleModuleUrl(module);
      navigate(url);
    } else {
      dispatch(openQualificationDrawer(module));
    }
  };

  return (
    <Grid
      sx={{ height: 1 }}
      container
      spacing={3}
      direction="column"
      alignItems="center"
      justifyContent="space-between"
      wrap="nowrap"
    >
      <Grid item>
        <AppIcon Icon={Illustration} sx={eligibilitySectionStyles.illustration} role="presentation" />
      </Grid>
      <Grid item>
        <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
          <Typography
            variant="large"
            fontFamily={fonts.heading}
            align="center"
            color="white"
            sx={{ display: 'block', mb: 1, maxWidth: '320px' }}
            fontWeight="Medium"
          >
            {content}
          </Typography>
          {isGuestUserFetching || isFetching ? (
            <Skeleton variant="rectangular" width="7.5rem" height="3rem" />
          ) : (
            <Button
              onClick={onFindEligibleModule}
              sx={{
                bgcolor: 'common.white',
                ':hover,:focus': { bgcolor: 'primary.light' },
              }}
            >
              {buttonLabel}
            </Button>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};
